import * as Actions from 'store/actions/app/credit_notes_cpe.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_credit_notes_cpe: false,
  credit_notes_cpe: [],
  total_credit_notes_cpe: 0,

  sending_credit_note_to_sunat_ids: [],
  sent_credit_note_to_sunat_ids: [],

  sending_uninformed_credit_notes_to_sunat: false,
  sent_uninformed_credit_notes_to_sunat_ids: [],
}

const creditNotesCPEReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_CREDIT_NOTES_CPE: {
      return {
        ...state,
        loading_credit_notes_cpe: action.payload.loading ?? state.loading_credit_notes_cpe,
        credit_notes_cpe: action.payload.items ?? state.credit_notes_cpe,
        total_credit_notes_cpe: action.payload.total ?? state.total_credit_notes_cpe,
      }
    }
    case Actions.SEND_CREDIT_NOTE_TO_SUNAT: {
      return {
        ...state,
        sending_credit_note_to_sunat_ids: toggleIdInArray(state.sending_credit_note_to_sunat_ids, action.payload.sending_id),
        sent_credit_note_to_sunat_ids: toggleIdInArray(state.sent_credit_note_to_sunat_ids, action.payload.sent_id),
        credit_notes_cpe: action.payload.data
          ? addOrUpdateObjectInArray(state.credit_notes_cpe, action.payload.data, 'nota_id')
          : state.credit_notes_cpe
      }
    }
    case Actions.SEND_UNINFORMED_CREDIT_NOTES_TO_SUNAT: {
      return {
        ...state,
        sending_uninformed_credit_notes_to_sunat: action.payload.sending ?? state.sending_uninformed_credit_notes_to_sunat,
        sent_uninformed_credit_notes_to_sunat_ids: action.payload.data ?? [],
      }
    }
    default: {
      return state
    }
  }
}
export default creditNotesCPEReducer
